export interface ErrorPayload {
  [key: string]: string;
}
export interface ErrorResponse {
  status: number;
  data?: ErrorPayload;
}

class HTTPResponse<T> {
  private readonly resResult: T;
  private readonly resStatus: Number | undefined;
  private readonly resError: ErrorResponse | undefined;

  get error(): ErrorResponse | undefined {
    return this.resError;
  }

  get result(): T {
    return this.resResult;
  }

  get status(): Number | undefined {
    return this.resStatus;
  }

  public constructor(result: T, error?: ErrorResponse, status?: Number) {
    this.resResult = result;
    this.resStatus = status;
    if (error) {
      this.resError = error;
    }
  }
}

export default HTTPResponse;
